/**
 * This is required for lazily loading the other chunks when the stageplayer is deployed somewhere on an external page.
 * Otherwise the chunks might not load.
 */

/* eslint-disable */
if (window.STAGEPLAYER_PUBLIC_PATH) {
  __webpack_public_path__ = window.STAGEPLAYER_PUBLIC_PATH;
}
